<template>
  <div>
    <div id="disconnected" style="display: none">
      <div class="closediv">
        <div class="icondiv"></div>
        <div class="titlediv">You are disconnected.</div>
        <div class="bodydiv">Please login again.</div>
        <a
          href="/logout.php"
          class="btn btn-primary btn-floating btn-lg btn-block"
          >Close</a
        >
      </div>
    </div>
    <div id="app" v-cloak :class="['locale_' + this.lang_id]">
      <app-header
        :user="user"
        :format-price="formatPrice(user.balance)"
        :languages="languages"
        :lang_id="lang_id"
        :current-time="currentTime"
        :sound-on="soundOn"
        :goodroad-on="goodroadOn"
        :open-drawer="openDrawer"
        :open-language="openLanguage"
        :statement-url="statementUrl"
        :bets-url="betsUrl"
        :gamehistory-url="gamehistoryUrl"
        :rules-url="rulesUrl"
        :notification-url="notificationUrl"
        :games="games"
        @set-Locale="setLocale"
        @toggle-sound="toggleSound"
        @toggle-mob-drawer="toggleMobDrawer"
        @check-balance="checkBalance"
        @toggle-mob-language="toggleMobLanguage"
        @toggle-goodroad="toggleGoodroad"
      />
      <div id="products">
        <template v-for="game in games">
          <tai-xiu
            :key="game.gID"
            class="game-container"
            :game-data="game"
            :sound-on="soundOn"
            :goodroad-on="goodroadOn"
            :loading="false"
            v-if="game.cID === 4"
          />

          <hi-lo
            :key="game.gID"
            class="game-container"
            :game-data="game"
            :sound-on="soundOn"
            :goodroad-on="goodroadOn"
            :loading="false"
            v-if="game.cID === 5"
          />

          <domino
            :key="game.gID"
            class="game-container"
            :game-data="game"
            :sound-on="soundOn"
            :goodroad-on="goodroadOn"
            :loading="false"
            v-if="game.cID === 6"
          />
          <!-- <se-die
          :key="game.gID"
          class="game-container"
          :game-data="game"
          :sound-on="soundOn"
          :goodroad-on="goodroadOn"
          :loading="false"
          v-if="game.cID === 13"
          />-->
          <!-- <max-racing
          :key="game.gID"
          class="game-container"
          :game-data="game"
          :sound-on="soundOn"
          :goodroad-on="goodroadOn"
          :loading="false"
          v-if="game.cID === 9"
          />-->
          <fantan
            :key="game.gID"
            class="game-container"
            :game-data="game"
            :sound-on="soundOn"
            :goodroad-on="goodroadOn"
            :loading="false"
            v-if="game.cID === 10"
          />
          <!-- <thai-hilo
          :key="game.gID"
          class="game-container"
          :game-data="game"
          :sound-on="soundOn"
          :goodroad-on="goodroadOn"
          :loading="false"
          v-if="game.cID === 11"
          />-->
        </template>

        <div class="bottomright">
          Powered by
          <span class="poweredby-logo-cont"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Row, Modal } from "iview";
import { TweenMax } from "gsap";
import axios from "./plugins/configs/axios";
// import devtool from "./plugins/configs/devtool";
import Sortable from "sortablejs";
import moment from "moment";
import {
  hi_lo_betTypes,
  tai_xiu_betTypes,
  domino_betTypes,
  maxracing_betTypes,
  fantan_betTypes,
  thaihilo_betTypes,
  languages,
} from "./plugins/configs/global";
import EventBus from "./plugins/configs/event-bus";
import AppHeader from "./plugins/components/commons/AppHeader";

export default {
  name: "app",
  data() {
    return {
      languages: languages,
      betsUrl: betsUrl,
      statementUrl: statementUrl,
      gamehistoryUrl: gamehistoryUrl,
      rulesUrl: rulesUrl,
      notificationUrl: notificationUrl,
      forceLogoutUrl: forceLogoutUrl,
      intervals: { qUpdate: null, qBalance: null, qTime: null },
      user: { username: null, balance: null, curr: null, checking: false },
      lang_id: 0,
      games: [],
      currentTime: "",
      openLanguage: false,
      openDrawer: false,
      soundOn: true,
      goodroadOn: true,
      options: {
        fullScreen: false,
        displayMode: window.innerWidth > 767 ? "normal" : "normal",
      },
    };
  },
  components: {
    AppHeader,
    Row,
    Modal,
  },
  watch: {
    "options.displayMode": function displayMode(a) {
      {
        for (let i = games.length - 1; i >= 0; i--) {
          this.games[i].viewreset = a;
        }
      }
    },
  },
  methods: {
    formatPrice(value) {
      let newVal = (value / 1).toFixed(2);
      return newVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    playWin() {
      if (this.soundOn) {
        winAudio.play();
      }
    },
    playLoss() {
      if (this.soundOn) {
        lossAudio.play();
      }
    },
    toggleSound: function () {
      this.soundOn = !this.soundOn;
    },
    toggleGoodroad: function () {
      this.goodroadOn = !this.goodroadOn;
    },
    toggleMobDrawer: function () {
      this.openDrawer = !this.openDrawer;
    },
    toggleMobLanguage: function () {
      this.openLanguage = !this.openLanguage;
    },
    onlyyou: function onlyyou(gameId) {
      let thestat = false;
      let fullornot = false;

      for (let i = games.length - 1; i >= 0; i--) {
        if (gameId != this.games[i].gID) {
          thestat = this.games[i].hidden;
        } else {
          fullornot = this.games[i].fullscreen;
        }
      }

      for (let i = games.length - 1; i >= 0; i--) {
        if (gameId != this.games[i].gID) {
          if (!fullornot) {
            this.games[i].hidden = true;
          } else {
            this.games[i].hidden = false;
          }
        } else {
          this.games[i].fullscreen = !this.games[i].fullscreen;
          this.$root.options.fullScreen = this.games[i].fullscreen;
        }
      }
    },
    popOut: function popOut(url) {
      let left = window.screen.width / 2 - (800 / 2 + 10);
      let top = window.screen.height / 2 - (600 / 2 + 50);
      let popout = window.open(
        url,
        "popoutwindow",
        "height=600,width=800,top=" +
          top +
          ",left=" +
          left +
          ",toolbar=no,menubar=no,scrollbars=yes,resizable=no,location=no,directories=no,status=no"
      );

      popout.focus();
    },
    checkTime: function checkTime() {
      // *** Refactor by using momentjs
      let dateObj = new Date();

      dateObj = new Date(
        dateObj.toLocaleString("en-US", { timeZone: "America/New_York" })
      );

      dateObj.setTime(
        dateObj.getTime() + 1000 * (60 * dateObj.getTimezoneOffset()) + 28800000
      );

      let now = moment(dateObj);

      this.currentTime = `${now.format("HH:mm:ss A MMM D, YYYY")} (GMT-4)`;
    },
    checkUser: async function () {
      // *** Refactor by using await/async promise
      try {
        let res = await axios.get(customerUrl);

        let resData = res.data;

        if (resData.error) {
          // If there is an error, force logout
          this.forceLogout(2, resData.error);
        } else {
          // Reassign user object with new data
          this.user = {
            ...this.user,
            data: resData.data,
            username: resData.data.username,
            curr: resData.data.curr,
            balance: isNaN(parseFloat(resData.data.balance))
              ? 0
              : parseFloat(resData.data.balance),
          };
          // Check user balance
          this.checkBalance();
        }
      } catch (e) {
        // If there is a res error, force logout
        this.forceLogout(3, e);
      }
    },
    checkBalance: async function () {
      // *** Refactor by using await/async promise
      let vm = this;
      this.user.checking = true;

      // Clear interval for checking balance
      clearInterval(this.intervals.qBalance);

      try {
        let res = await axios.get(customerBalanceUrl);

        let resData = res.data;

        if (resData.error) {
          // If there is an error, force logout
          this.forceLogout(4, resData.error);
        } else {
          this.user.balance = isNaN(parseFloat(resData.data.balance))
            ? 0
            : parseFloat(resData.data.balance);
        }
      } catch (e) {
        // If there is a res error, force logout
        this.forceLogout(5, e);
      }

      this.user.checking = false;

      // Recreate interval for checking balance
      this.intervals.qBalance = setInterval(function () {
        vm.checkBalance();
      }, checkBalanceTimer);
    },
    setBalance: function setBalance(balance) {
      this.user.balance = isNaN(parseFloat(balance)) ? 0 : parseFloat(balance);
    },
    checkTrendLot: function checkTrendLot(a) {
      // ??? need to refactor
      let b = arguments.length && arguments[1] !== void 0 ? arguments[1] : null;
      "open-result" != a.status &&
        axios
          .get(trendlotUrl + "?gID=" + a.gID + "&dID=" + a.drawID)
          .then(function (d) {
            let f = d.data;

            if (0 != f.error) {
              this.forceLogout(6, f.error);
            } else if (((a.result = f.data), (a.stat = f.stat), b)) {
              let g = f.data.map(function (j) {
                  return parseInt(j.drawID);
                }),
                h = g.indexOf(parseInt(b));
              0 > h &&
                setTimeout(function () {
                  this.checkTrendLot(a, b);
                }, 2000);
            }
          })
          .catch(function () {});
    },
    checkUpdate: async function () {
      let vm = this;
      let arg = 0 < arguments.length && arguments[0] !== void 0 && arguments[0];

      clearInterval(this.intervals.qUpdate);

      try {
        let res = await axios.get(drawsCheckUpdateUrl);

        let resData = res.data;

        if (resData.error) {
          this.forceLogout(7, resData.error);
        } else {
          this.games = resData.data;
          this.games = this.games.map((item) => {
            return {
              ...item,
              productID: parseInt(item.productID),
              gID: parseInt(item.gID),
              drawID: parseInt(item.drawID),
              closeInterval: parseInt(item.closeInterval),
            };
          });
        }
      } catch (e) {
        this.forceLogout(8, e);
      }

      this.intervals.qUpdate = setInterval(function () {
        vm.checkUpdate();
      }, checkUpdateTimer);
    },
    checkBetList: async function () {
      let vm = this;
      // *** Refactor by using await/async promise
      // console.log("ClearFromAppStake");
      for (let i = this.games.length - 1; i >= 0; i--) {
        clearStakeRecord(this.games[i].gID);
      }

      try {
        let res = await axios.get(custBetUrl);
        let resData = res.data;

        if (resData.error) {
          // If there is an error, force logout
          this.forceLogout(10, resData.error);
        } else {
          // Remapping bet list
          let remappedBetList = resData.data.map(function (item) {
            let getTypeValue;
            if (item.bet_addtional_value) {
              getTypeValue = item.bet_addtional_value;
            } else {
              getTypeValue = "o" + item.betID;
            }

            return {
              ...item,
              gID: parseInt(item.gID),
              type: getTypeValue,
            };
          });

          // Set session record for stake records
          //sessionStorage.getItem("stake-records")

          sessionStorage.setItem(
            "stake-records",
            JSON.stringify(remappedBetList)
          );

          // for (let i = 0; i < this.games.length; i++) {

          //   this.games[i].betList = 1;
          // }
          EventBus.$emit("update-session-storage");
        }
      } catch (e) {
        // If there is a res error, force logout
        this.forceLogout(11, e);
      }
    },
    setLocale: function setLocale(locale) {
      // Set user selected locale
      this.lang_id = locale;
      this.$i18n.locale = this.languages[locale].code;
      let formData = new FormData();
      formData.append("lang_id", locale);
      axios.post(langUrl, formData);
    },
    openWindow: function openWindow(url) {
      // Reassign url with necessary params
      // console.log(url);
      let newUrl =
        0 < url.indexOf("?")
          ? `${url}&l=${this.lang_id}`
          : `${url}?l=${this.lang_id}`;

      // Get top left position
      let top = window.screen.width / 2 - (openWindowSize[0] / 2 + 10);
      let left = window.screen.height / 2 - (openWindowSize[1] / 2 + 50);

      // Open new window
      let newWindow = window.open(
        newUrl,
        "childwindow",
        `height=${openWindowSize[1]},width=${openWindowSize[0]},top=${top},left=${left},toolbar=no,menubar=no,scrollbars=yes,resizable=no,location=no,directories=no,status=no"`
      );

      // Set focus for the newly open window
      newWindow.focus();
    },
    forceLogout: function forceLogout(code, error) {
      // window.location.replace(forceLogoutUrl + "&c=" + code + "&e=" + error);
      document.getElementById("app").style.display = "none";
      document.getElementById("disconnected").style.display = "block";
      var highestTimeoutId = setTimeout(";");
      for (var i = 0; i < highestTimeoutId; i++) {
        clearTimeout(i);
      }
    },
    refreshPage: function refreshPage() {
      // console.log("refreshPage");
      window.location.reload();
      // Check update and bet list
      this.checkUpdate();
      this.checkBetList();
    },
  },
  created: function created() {
    let vm = this;
    this.checkUser();
    this.checkBetList();

    this.intervals.qTime = setInterval(function () {
      vm.checkTime();
    }, 1000);
  },
  mounted: function mounted() {
    if (window.lang_id == null) {
      window.lang_id = 0;
    }
    if (window.app == null) {
      window.app = false;
    }
  
    this.$root.app = window.app;
    this.setLocale(window.lang_id);
    this.$root.showAlert = 0;
    this.checkTime();
    let vm = this;

    TweenMax.ticker.useRAF(false);
    TweenMax.ticker.lagSmoothing(0);

    setTimeout(function () {
      if (window.innerWidth > 767) {
        let el = document.getElementById("products"),
          f = Sortable.create(el, {
            handle: ".game-header",
            draggable: ".game-container",
            ghostClass: "sortable-ghost",
            chosenClass: "sortable-chosen",
            dragClass: "sortable-drag",
            onChoose: function onChoose() {
              let g = document.getElementById("app");
              g.click();
              // console.log(g);
            },
          });
      }
    }, 2000);

    this.checkUpdate();

    let timestampA = new Date().getTime();
    let refreshPageIfNecessary = function () {
      let timestampB = new Date().getTime();
      // console.log(timestampB - timestampA);
      if (timestampB - timestampA > 1.2e5) {
        console.log("refresh");
        window.location.reload();
      } else if (timestampB - timestampA > 5e3) {
        vm.refreshPage();
      }

      timestampA = timestampB;
      setTimeout(refreshPageIfNecessary, 1000);
    };

    refreshPageIfNecessary();
  },
};
</script>
<style>
#disconnected .btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.btn-primary {
  width: 140px;
  margin: 0 auto;
  height: 40px;
  line-height: 40px;
  padding: 0;
  font-size: 12px;
  font-weight: bold;
}
div#disconnected {
  position: absolute;
  z-index: 999999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}

.closediv {
  background: #182849;
  color: #d1dfff;
  text-align: center;
  max-width: 1000px;
  width: 80%;
  padding-top: 20px;
  padding-bottom: 30px;
  border-radius: 10px;
  position: absolute;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 50px;
}

.icondiv {
  width: 100px;
  height: 100px;
  background: url("/assets/img/logout-icon.png") no-repeat center center;
  margin: 0 auto 10px;
}

.titlediv {
  font-size: 18px;
  font-weight: bold;
  color: #3ae7fd;
  text-align: center;
  margin-bottom: 10px;
}

.bodydiv {
  font-size: 14px;
  font-weight: bold;
  color: #d1dfff;
  text-align: center;
  margin-bottom: 25px;
}

.btn-primary {
  width: 140px;
  margin: 0 auto;
  height: 40px;
  line-height: 40px;
  padding: 0;
  font-size: 12px;
  font-weight: bold;
}

#app {
  user-select: none;
}

#app {
  width: 100%;
  height: 100vh;
  overflow: scroll;
  background: #444444;
}

#app #products {
  text-align: left;
  padding: 0;
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 5;
  max-width: 1400px;
  padding-bottom: 288px;
  display: flex;
  flex-flow: row wrap;
}

#app #products:after {
  content: "";
  display: flex;
  clear: both;
}

[v-cloak]::before {
  content: "loading…";
}

.game-container {
  border-radius: 10px;
  position: relative;
  font-family: Poppins, Arial, sans-serif;
  padding: 5px;
  width: 100%;
  display: block;
  flex: 0 0 auto;
}

.products {
  max-width: 1400px;
}
.bottomright {
  position: absolute;
  display: flex;
  bottom: 22px;
  right: 16px;
  color: white;
  font-size: 10px;
  line-height: 20px;
}

.poweredby-logo-cont {
  background: transparent url(./plugins/assets/images/common/poweredby.png)
    center no-repeat;
  background-size: contain;
  display: flex;
  height: 20px;
  width: 80px;
}

@media print, screen and (min-width: 676px) {
  .game-container {
    width: 50%;
  }
}
@media print, screen and (min-width: 992px) {
  .game-container {
    width: 33.33333%;
  }
}
@media print, screen and (min-width: 1320px) {
  .game-container {
    width: 25%;
  }
}

/* .tr a {
  width: 0;
  height: 0;
  border-top: 50px solid transparent;
  border-left: 100px solid red;
  border-bottom: 50px solid transparent;
} */

/* .tr a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 122, 199, 0.7);
  transform-origin: 0 100%;
  transform: rotate(45deg);
  transition: background-color 0.3s;
} */
/** hover effect **/
.tr a:hover {
  background: rgba(255, 165, 0, 0.7);
}
.tr:hover {
  border-left: 100px solid white;
}
</style>
